<template>
  <div class="forum-guests">
    <div class="item" v-for="(item,index) in schedule" :key="index">
      <div class="item-content">
        <div class="head">
          <span class="time">{{item.start_at | parseTime}}</span>
          <img
            src="https://summit-img.geekpark.net/ifx/images/%E5%B0%8F%E4%BC%97%E4%B8%8E%E5%A4%A7%E4%BC%97.svg"
            style="height: 2.2vh;" v-if="item.description === '小众与大众'">
          <img
            src="https://summit-img.geekpark.net/ifx/images/%E7%AA%81%E7%A0%B4%E4%B8%8E%E4%BC%A0%E6%89%BF.svg"
            style="height: 2.2vh;" v-if="item.description === '突破与传承'">
          <img
            src="https://summit-img.geekpark.net/ifx/images/%E8%99%9A%E6%8B%9F%E4%B8%8E%E7%8E%B0%E5%AE%9E.svg"
            style="height: 2.2vh;" v-if="item.description === '虚拟与现实'">
          <img
            src="https://summit-img.geekpark.net/ifx/images/%E7%A7%91%E6%8A%80%E4%B8%8E%E4%BA%BA%E6%80%A7.svg"
            style="height: 2.2vh;" v-if="item.description === '科技与人性'">
          <img
            src="https://summit-img.geekpark.net/ifx/images/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E4%B8%8E%E4%BA%BA.svg"
            style="height: 2.2vh;" v-if="item.description === '人工智能与人'">
          <img
            src="https://summit-img.geekpark.net/ifx/images/%E4%BC%A0%E7%BB%9F%E4%B8%8E%E5%88%9B%E6%96%B0.svg"
            style="height: 2.2vh;" v-if="item.description === '传统与创新'">
        </div>
        <h2>{{item.title}}</h2>
        <div v-if="item.image" style="position: absolute; bottom: 2vh;text-align: left">
          <img :src="item.image" style="width: 70%;vertical-align: bottom;">
        </div>
        <div class="guest" v-else>
          <img
            :src="item.guests[0].avator.url"
            alt="">
          <div class="guest-info">
            <h2>{{item.guests[0].company}}</h2>
            <p>{{item.guests[0].name}}</p>
            <p>{{item.guests[0].title}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'ForumGuests',
    props: ['schedule'],
    created() {
      // this.bindHover();
    },
    methods: {
      bindHover() {
        $('.right')
          .on('mouseenter', '.guest0', function (e) {
            $(this)
              .parent()
              .children('.guest1,.guest2,.guest3')
              .hide();
            $(this)
              .addClass('guest-hover');
          })
          .on('mouseenter', '.guest1', function (e) {
            $(this)
              .parent()
              .children('.guest0,.guest2,.guest3')
              .hide();
            $(this)
              .addClass('guest-hover');
          })
          .on('mouseenter', '.guest2', function (e) {
            $(this)
              .parent()
              .children('.guest0,.guest1,.guest3')
              .hide();
            $(this)
              .addClass('guest-hover');
          })
          .on('mouseenter', '.guest3', function (e) {
            $(this)
              .parent()
              .children('.guest0,.guest1,.guest2')
              .hide();
            $(this)
              .addClass('guest-hover');
          })
          .on('mouseleave', '.guest0', function (e) {
            $(this)
              .parent()
              .children('.guest0,.guest1,.guest2,.guest3')
              .show();
            $(this)
              .removeClass('guest-hover');
          })
          .on('mouseleave', '.guest1', function (e) {
            $(this)
              .parent()
              .children('.guest0,.guest1,.guest2,.guest3')
              .show();
            $(this)
              .removeClass('guest-hover');
          })
          .on('mouseleave', '.guest2', function (e) {
            $(this)
              .parent()
              .children('.guest0,.guest1,.guest2,.guest3')
              .show();
            $(this)
              .removeClass('guest-hover');
          })
          .on('mouseleave', '.guest3', function (e) {
            $(this)
              .parent()
              .children('.guest0,.guest1,.guest2,.guest3')
              .show();
            $(this)
              .removeClass('guest-hover');
          });
      },
    },
    filters: {
      parseTime: function (date) {
        return moment(date)
          .format('HH:mm');
      }
    }
  };
</script>

<style scoped lang="less">
  .forum-guests {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 160vh;
    height: 86vh;
    transform: translateY(-1vh);
    .item {
      display: flex;
      box-sizing: border-box;
      width: 40vh;
      height: 22vh;
      padding: 1vh;
      background-clip: content-box;
      background-color: #f9f9f9;

      .item-content {
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh 1.8vh 0vh 1.8vh;

        .head {
          width: 100%;
          display: flex;
          justify-content: space-between;
          font-size: 2.5vh;
          font-weight: 800;

          .time {
            color: #ff3c00;
            font-family: SyncopateBold;
          }
        }

        > h2 {
          margin-top: .8vh;
          line-height: 1.2;
          text-align: left;
          font-size: 2vh;
        }

        .guest {
          display: flex;
          justify-content: flex-start;
          position: absolute;
          bottom: 2vh;
          width: 100%;
          text-align: left;

          img {
            width: 9.2vh;
            height: 9.2vh;
            border-radius: 4.6vh;
          }

          .guest-info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 2.5vh;
            padding: .4vh 0;
            font-size: 1.8vh;

            h2 {
              color: #ff3c00;
              font-size: 2.2vh;
            }

            p {
              white-space: nowrap;

              &:last-child {
                color: #535353;
              }
            }
          }
        }

        .guest0, .guest1, .guest2, .guest3 {
          .guest;
          width: 8.4vh;
          height: 8.4vh;

          > .guest-info {
            display: none;
          }

          > img {
            width: 8.4vh;
            height: 8.4vh;
          }
        }

        .guest1 {
          left: 28%;
        }

        .guest2 {
          left: 51%;
        }

        .guest3 {
          left: 75%;
        }

        .guest-hover {
          width: 100%;
          left: 4.5%;
          transition: left .3s linear;

          > .guest-info {
            display: flex;
            visibility: visible;
          }
        }
      }

    }
  }

</style>
